import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faMagnifyingGlass } from "@performyard/fontawesome/pro-regular-svg-icons";
import { Text } from "@performyard/py-components";

export const NoResultsFound = () => (
	<div className="absolute inset-x-0 top-14 flex h-[320px] flex-col items-center justify-center gap-2 rounded-1 border border-solid border-neutral-3 bg-neutral-0">
		<div className="flex items-center justify-center rounded-full bg-neutral-1 p-3">
			<FontAwesomeIcon icon={faMagnifyingGlass} className="size-5 text-neutral-5" />
		</div>
		<Text size="paragraph-2" weight="semi-bold" color="neutral-9">
			No Results Found
		</Text>
	</div>
);
